export default __webpack_public_path__ + "img/a9377ce9c44b06a4c7d292d7a794a27c.svg";